import React from 'react';
import { ImageProps } from '.';

const SvgZexpressSimpleGlobal = ({ size = 52, ...props }: ImageProps): JSX.Element => {
  return (
    <svg width={size} height={(size && Math.floor(size / 1.625)) || 32} fill='none' viewBox='0 0 52 32' {...props}>
      <path
        fill='#9C53F8'
        d='M36.058 0H15.942C7.138 0 0 7.16 0 15.992v.017C0 24.84 7.138 32 15.942 32h20.116C44.862 32 52 24.84 52 16.009v-.018C52 7.16 44.862 0 36.058 0Z'
      />
      <path
        fill='#fff'
        d='M9.3 12.64c1.604-3.099 4.886-5.28 8.446-5.28l.001.001c4.713 0 8.131 3.82 7.637 8.533-.497 4.713-4.718 8.534-9.43 8.534-3.607 0-6.456-2.238-7.373-5.402a.719.719 0 0 1 .69-.917h6.008l-.274 1.097c-.214.857.783 1.495 1.472.943l4.611-3.691a.922.922 0 0 0 .161-1.274l-2.771-3.692a.923.923 0 0 0-1.633.33l-.465 1.868H9.937a.718.718 0 0 1-.637-1.05ZM29.728 12.014l.378-3.59H40.22L34.36 20.187h4.367l-.378 3.599H28.235l5.895-11.773h-4.402Z'
      />
    </svg>
  );
};

export default SvgZexpressSimpleGlobal;
